import { connect } from 'react-redux';
import { get } from 'lodash';
import View from './component';
import { setMessage } from './actions';

export const ConfirmActionManager = {
  setCallbacks({ ok = () => {}, cancel = () => {} }) {
    this.ok = () => {
      ok();
      this.clearCallbacks();
    };

    this.cancel = () => {
      cancel();
      this.clearCallbacks();
    };
  },

  clearCallbacks() {
    this.ok = () => {};
    this.cancel = () => {};
  },
};

const mapStateToProps = (state) => ({
  message: get(state, 'confirm.message'),
  maxWidth: get(state, 'confirm.maxWidth'),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(setMessage({ message: null })),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
